import { z } from 'zod';
export const regionSearchSchema = z.object({
    query: z.string().min(1).max(100),
});
